// frontend/src/hooks/useKeyboardNavigation.js
import { useEffect } from "react";

const useKeyboardNavigation = (
  onPrevious,
  onNext,
  currentIndex,
  totalLength,
  hasMore = false, // ← Add this parameter
) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        event.target.isContentEditable
      ) {
        return;
      }

      switch (event.key) {
        case "ArrowLeft":
          if (currentIndex > 0) {
            event.preventDefault();
            onPrevious();
          }
          break;
        case "ArrowRight":
          // OLD: if (currentIndex < totalLength - 1)
          // NEW: Allow navigation if not at end OR if there are more pages
          if (currentIndex < totalLength - 1 || hasMore) {
            // ← Changed
            event.preventDefault();
            onNext();
          }
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [onPrevious, onNext, currentIndex, totalLength, hasMore]); // ← Add hasMore to deps
};

export default useKeyboardNavigation;
